module.exports = __webpack_public_path__ + "img/icon-level-5.0a871be9.png";